<h2 class="text-bold" mat-dialog-title>Email Update Confirmation </h2>
<mat-dialog-content>
    <p class="dialog-content">Updating the user’s email will reset their password and MFA.</p>
    <p class="dialog-content">An email will be sent with a reset link, and they will be required to configure MFA upon login.</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn text-white" (click)="onSuccessResponse()">Confirm</button>
  <button mat-button type="button" class="btn btn-lg btn-light-primary continue-btn text-gold" (click)="onNegativeResponse()">Cancel</button>
</mat-dialog-actions>